import { PropType } from 'vue';
import BaseSetupService from '@/setup/BaseSetupService';
import TaskEntity from '@/entity/TaskEntity';
import UserTaskTemplateApiAgency from '@/api/UserTaskTemplateApiAgency';
import UserApiAgency from '@/api/UserApiAgency';
import { reactive } from 'vue';

type Props = SetupProps<typeof TaskModalEditSetupService.props>

export type TaskType = 'new' | 'template'

export default class TaskModalEditSetupService extends BaseSetupService<Props> {
	static readonly props = {
		task: {
			type: Object as PropType<TaskEntity>,
			required: true as const,
		},
	};

	private _modal?: OrionModal;
	private readonly state = reactive({
		taskOptions: [] as IUserTaskTemplateModel[],
		taskTypeOptions: ['new', 'template'] as TaskType[],
		assignedUserOptions: [] as IUserAgencyForListModel[],
		isPerformingAjax: false,
		selectedTaskType: undefined as Undef<TaskType>,
	});

	taskClone: TaskEntity;

	get taskOptions () { return this.state.taskOptions; }
	get taskTypeOptions () { return this.state.taskTypeOptions; }
	get isPerformingAjax () { return this.state.isPerformingAjax; }
	get assignedUserOptions () { return this.state.assignedUserOptions; }

	get selectedTaskType () { return this.state.selectedTaskType; }
	set selectedTaskType (val) { this.state.selectedTaskType = val; }


	constructor (props?: Props, _modal?: OrionModal) {
		super(props);
		this._modal = _modal;
		this.taskClone = this.props.task.clone().associateTempWorker(this.props.task.tempWorker);
	}

	protected onMounted () {
		this.loadDataAsync();
	}


	private async loadDataAsync () {
		this._modal?._loader()?.show('Chargement des données...');

		const { data: taskOptions } = await UserTaskTemplateApiAgency.grid();
		this.state.taskOptions = taskOptions.list;

		if (this.props.task.tempWorker) {
			const { data: assigneOptions } = await UserApiAgency.assignableUser(this.props.task.tempWorker.id);
			this.state.assignedUserOptions = assigneOptions;
		}

		if (!this.props.task.isNew) {
			this.state.selectedTaskType = 'new';
		}

		this._modal?._loader()?.hide();
	}
}
